export const WTBProtocol = {
  ROUND_START: "wtb:round_start",
  TIME_UPDATE: "wtb:time_update",
  ANSWER_SUBMITTED: "wtb:answer_submitted",
  REVEAL_ANSWERS: "wtb:reveal_answers",
  VOTING_START: "wtb:voting_start",
  VOTE_SUBMITTED: "wtb:vote_submitted",
  VOTE_RESULT: "wtb:vote_result",
  AI_VOTING_START: "wtb:ai_voting_start",
  AI_VOTE_SUBMITTED: "wtb:ai_vote_submitted",
  FINAL_RESULTS: "wtb:final_results",
  SYNC_GAME_STATE: "wtb:sync_game_state",
  ERROR: "wtb:error",
} as const;

export type WTBProtocolType = typeof WTBProtocol[keyof typeof WTBProtocol];

export interface WTBPlayerState {
  id: number;
  name: string;
  avatar: string;
  isActive: boolean;
  isBot: boolean;
  score: number;
  answers: (string | null)[];
  votes: (number | null)[];
  finalVote?: number;
}

export interface WTBAnswer {
  playerId: number;
  answer: string;
  isBot: boolean;
  votes?: number;
}

export interface WTBProtocolData {
  [WTBProtocol.ROUND_START]: {
    round: number;
    totalRounds: number;
    question: string;
    leftTime: number;
    players: WTBPlayerState[];
  };
  [WTBProtocol.TIME_UPDATE]: {
    leftTime: number;
  };
  [WTBProtocol.ANSWER_SUBMITTED]: {
    playerId: number;
    answer: string;
  };
  [WTBProtocol.REVEAL_ANSWERS]: {
    answers: WTBAnswer[];
    round: number;
    delayTime: number;
  };
  [WTBProtocol.VOTING_START]: {
    round: number;
    leftTime: number;
    answers: WTBAnswer[];
    players: WTBPlayerState[];
  };
  [WTBProtocol.VOTE_SUBMITTED]: {
    playerId: number;
  };
  [WTBProtocol.VOTE_RESULT]: {
    round: number;
    topAnswers: WTBAnswer[];
    botAnswers: WTBAnswer[];
    players: WTBPlayerState[];
  };
  [WTBProtocol.AI_VOTING_START]: {
    leftTime: number;
    players: WTBPlayerState[];
  };
  [WTBProtocol.AI_VOTE_SUBMITTED]: {
    voterId: number;
    votedPlayerId: number;
  };
  [WTBProtocol.FINAL_RESULTS]: {
    botPlayers: WTBPlayerState[];
    correctGuesserIds: number[];
    totalPlayers: number;
    players: WTBPlayerState[];
  };
  [WTBProtocol.SYNC_GAME_STATE]: {
    currentPhase: string;
    currentRound: number;
    totalRounds: number;
    leftTime: number;
    question: string;
    players: WTBPlayerState[];
    roundResults?: Array<{
      round: number;
      topAnswers: WTBAnswer[];
      botAnswers: WTBAnswer[];
    }>;
    finalResults?: {
      botPlayers: WTBPlayerState[];
      correctGuesserIds: number[];
      totalPlayers: number;
    };
  };
  [WTBProtocol.ERROR]: {
    message: string;
    code: string;
  };
}
